import {
	BaseError,
} from './BaseError';

export class PostSpecificationIgnoredError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
